import PaymentsRounded from '@mui/icons-material/PaymentsRounded';
import { useQuery } from '@tanstack/react-query';
import { api, unwrap } from '../api/client';
import { useAuth } from '../auth/AuthProvider';
import { businessDate, money } from '../lib/format';
import { useShop } from '../shop/ShopProvider';
import type { LinkedGroup } from './MoreMenu';

type Filter =
  | { salesInvoiceId: string }
  | { supplierInvoiceId: string }
  | { salesOrderId: string }
  | { purchaseOrderId: string }
  | { contactId: string };

/** The payments allocated to a document (or an order's documents), as a ⋯ menu group. */
/** Not fetched while `filter` is null. */
export function useLinkedPayments(filter: Filter | null): LinkedGroup {
  const { can } = useAuth();
  const { format } = useShop();
  const q = useQuery({
    queryKey: ['payments', 'linked', filter],
    queryFn: () => unwrap(api.GET('/payments', { params: { query: { ...filter, pageSize: 20 } } })),
    enabled: filter !== null && can('payments.view'),
  });
  return {
    key: 'payments',
    title: 'Payments',
    icon: <PaymentsRounded fontSize="small" />,
    total: q.data?.page.total,
    docs: (q.data?.data ?? []).map((p) => ({
      id: p.id,
      label: p.number,
      hint: `${businessDate(p.paymentDate, format)} · ${money(p.amount, format)}`,
      to: `/payments/${p.id}`,
    })),
  };
}
